import script from "./WebChatroom.vue?vue&type=script&setup=true&lang=js"
export * from "./WebChatroom.vue?vue&type=script&setup=true&lang=js"

import "./WebChatroom.vue?vue&type=style&index=0&id=8ae13314&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ae13314"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerBars from 'quasar/src/components/spinner/QSpinnerBars.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QInput,QIcon,QScrollArea,QTree,QBtn,QSeparator,QAvatar,QImg,QSpinnerBars,QRadio,QBadge});
